import type { ResourceServiceType } from "@core-ui/ContextServices/ResourceService/ResourceService";
import type { Node } from "prosemirror-model";

const deleteDrawio = async (nodes: Node[], resourceService: ResourceServiceType) => {
	for (const node of nodes) {
		if (node.type.name !== "drawio") continue;
		await resourceService.deleteResource(node.attrs.src);
	}
};

export default deleteDrawio;
